
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M19.5 11.97C20.43 11.97 21.28 12.25 22 12.73V7.97001C22 6.87001 21.1 5.97001 20 5.97001H13.71L12.65 4.91001L13.71 3.85001C13.91 3.65001 13.91 3.34001 13.71 3.14001C13.51 2.94001 13.2 2.94001 13 3.14001L10.17 5.97001C9.97002 6.17001 9.97002 6.48001 10.17 6.68001C10.37 6.88001 10.68 6.88001 10.88 6.68001L11.94 5.62001L13 6.68001V8.97001C13 10.07 12.1 10.97 11 10.97H10.46C11.41 12.03 12 13.43 12 14.97C12 15.31 11.96 15.64 11.91 15.97H15.05C15.3 13.73 17.19 11.97 19.5 11.97Z' fill='#323232'/><path d='M19.5 12.97C17.57 12.97 16 14.54 16 16.47C16 18.4 17.57 19.97 19.5 19.97C21.43 19.97 23 18.4 23 16.47C23 14.54 21.43 12.97 19.5 12.97ZM19.5 17.97C18.67 17.97 18 17.3 18 16.47C18 15.64 18.67 14.97 19.5 14.97C20.33 14.97 21 15.64 21 16.47C21 17.3 20.33 17.97 19.5 17.97Z' fill='#323232'/><path d='M4 8.97H9C9 7.87 8.1 6.97 7 6.97H4C3.45 6.97 3 7.42 3 7.97C3 8.53 3.45 8.97 4 8.97Z' fill='#323232'/><path d='M9.83 13.79L9.65 13.32L10.58 12.97C10.12 11.91 9.3 11.06 8.27 10.54L7.87 11.43L7.41 11.22L7.81 10.32C7.26 10.11 6.64 9.97 6 9.97C5.47 9.97 4.96 10.08 4.48 10.23L4.82 11.14L4.35 11.32L4 10.4C2.94 10.86 2.09 11.68 1.57 12.71L2.46 13.11L2.25 13.57L1.35 13.17C1.13 13.72 1 14.33 1 14.97C1 15.5 1.11 16.01 1.26 16.49L2.17 16.15L2.35 16.62L1.42 16.97C1.88 18.03 2.7 18.88 3.73 19.4L4.13 18.51L4.59 18.72L4.19 19.62C4.76 19.84 5.37 19.97 6.01 19.97C6.54 19.97 7.05 19.86 7.53 19.71L7.18 18.8L7.65 18.62L8 19.55C9.06 19.09 9.91 18.27 10.43 17.24L9.54 16.84L9.75 16.38L10.65 16.78C10.87 16.21 11 15.6 11 14.96C11 14.43 10.89 13.92 10.74 13.44L9.83 13.79ZM7.15 17.75C5.62 18.38 3.86 17.66 3.23 16.13C2.6 14.6 3.32 12.84 4.85 12.21C6.38 11.58 8.14 12.3 8.77 13.83C9.41 15.36 8.68 17.11 7.15 17.75Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-agriculture`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconAgriculture

    ```js
    <b-new-b-icon-agriculture />
    ```
</docs>


